export default __webpack_public_path__ + "static/media/1.eaa4de30.png";